import { Card, Grid, Typography } from "@mui/material";
import React from "react";
import FilterComponent from "./Components/FosList/FilterComponent";
import TableComponent from "./Components/FosList/FosListTable";
import { useState } from "react";
import { useEffect } from "react";
import { GetFosList } from "API/fos_ist/api";
import BackdropLoader from "./Components/General/Loader";
import SnackBar from "./Components/General/SnackBar";
// import SubCard from "ui-component/cards/SubCard";



const FosList = () => {
    const [FilterData, setFilterData] = useState({ key: "", value: "" })
    const [Page, setPage] = useState(1);
    const [IsLoading, setIsLoading] = useState(false);
    const [Alert, setAlert] = useState({
        open: false,
        message: "",
        type: "success"
    })
    const [Data, setData] = useState(null);

    const handlePageChange = (event, value) => {
        setPage(value);
        GetFosList(value+1, FilterData, setData, setIsLoading, handleAlertOpen)
    }

    const handleAlertOpen = (message, type) => {
        setAlert({
            open: true,
            message: message,
            type: type
        });
    };

    const handleAlertClose = () => {
        setAlert(((prevData => {
            return {
                ...prevData,
                open: false,
            };
        })));
    }

    useEffect(() => {
        GetFosList(Page, FilterData, setData, setIsLoading, handleAlertOpen)
    }, [])


    const HandleGet =()=>{
        GetFosList(Page, FilterData, setData, setIsLoading, handleAlertOpen);
    }


    const HandleSearch =()=>{
        if (FilterData.value === "" || FilterData.key === "") {
            handleAlertOpen("Please enter a value and its category to search", "error");
            return;
        }
        setIsLoading(true);
        GetFosList(Page, FilterData, setData, setIsLoading, handleAlertOpen);
    }

    const HandleReset =()=>{
        setFilterData({ key: "", value: "" });
        setPage(1);
        GetFosList(1, { key: "", value: "" }, setData, setIsLoading, handleAlertOpen);
    }



    const handleFilterChange = (key, value) => {
        if (key === "value") {
            if (/^[0-9A-Za-z ]*$/.test(value)) {

                setFilterData(((prevData) => {
                    return {
                        ...prevData,
                        [key]: value
                    };
                }));
            }
        }
        else {
            setFilterData(((prevData) => {
                return {
                    ...prevData,
                    [key]: value
                };
            }));
        }
    };
    return (
        <Grid container>
            <BackdropLoader open={IsLoading} />

            <SnackBar open={Alert.open} type={Alert.type} message={Alert.message} handleClose={handleAlertClose} />
            <Grid item xs={12}>
                <Card   sx={{ padding: 1, marginBottom: 1 ,backgroundColor: "#fff",paddingLeft:1}}>
                    <Typography variant="h5" sx={{ color: "#20415C" }} fontWeight={600} >
                        Filter
                    </Typography>
                </Card>
            </Grid>
            <Grid item xs={12}>
                <FilterComponent data={FilterData} handleChange={handleFilterChange} handleSearch={HandleSearch} handleClear={HandleReset}/>
            </Grid>
            <Grid item xs={12}>
                <TableComponent data={Data} page={Page} handlePageChange={handlePageChange} handleGet={HandleGet} setIsLoading={setIsLoading} handleAlertOpen={handleAlertOpen} IsLoading={IsLoading}/>
            </Grid>
        </Grid>
    );
}


export default FosList;